import React from 'react';
import { connect } from "react-redux";
import ListErrors from '../../Utils/ListErrors';
import { getLabel } from '../../../language';
import '../../../css/login.css';
import { LOGIN, LOGIN_PAGE_UNLOADED } from "../../../constants/actionTypes";
import agent from "../../../agent";
import FacebookLogin from "react-facebook-login";

const mapStateToProps = state => ({ ...state.auth, token: state.common && state.common.token });

const mapDispatchToProps = dispatch => ({
    onSubmit: (email, password, rememberMe) =>
        dispatch({ type: LOGIN, payload: agent.Auth.login(email, password, rememberMe), pollyLogin: true, pathname: window.location.pathname }),
    onUnload: () =>
        dispatch({ type: LOGIN_PAGE_UNLOADED }),
    facebookLogin: (accessToken) =>
        dispatch({ type: LOGIN, payload: agent.Auth.facebookLogin(accessToken), pollyLogin: true, pathname: window.location.pathname })
});

export class LoginView extends React.Component {
    constructor() {
        super();
        this.state = {
            email: "",
            password: "",
            rememberMe: "",
        }
    }

    componentWillMount() {
        this.loginWIthTwtter()
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.token !== nextProps.token && nextProps.token) {
            window.location.reload();
        }
    }

    submitForm = () => {
        const { email, password, rememberMe } = this.state
        this.props.onSubmit(email, password, rememberMe);
    };

    handelChange = (e) => {
        this.setState({
            [e.target.name]: e.target.name === "rememberMe" ? (e.target.checked ? "on" : "off") : e.target.value
        })
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    responseFacebook = (response) => {
        if (response && response.accessToken) {
            this.props.facebookLogin(response.accessToken)
        }
    }

    componentClicked = () => { }

    loginWIthTwtter = () => {
        agent.Auth.getAuthToken(window.location.origin + "/login" + '?redirectUrl=' + window.location.pathname).then(res => {
          window.location.href = `https://api.twitter.com/oauth/authenticate?oauth_token=${res.oauth_token}`;
            this.setState({
                oauth_token: res.oauth_token,
            })
        }, err => {
            // this.setState({
            //     errMsg: err.message
            // })
            console.log(err)
        })
    }

    render() {
        const { email, password, rememberMe } = this.state
        return (
            <div className="content login-view-modal">
                <ListErrors errors={this.props.errors} />
                {/*<div className="text-danger">{this.state.errMsg}</div>*/}
                <div className="forms-group">
                    <div className="form-group">
                        <input
                            className="form-control"
                            type="email"
                            name="email"
                            placeholder={getLabel(1)}
                            value={email}
                            onChange={this.handelChange}
                        />
                    </div>
                </div>
                <div className="forms-group">
                    <div className="form-group">
                        <input
                            className="form-control"
                            type="password"
                            name="password"
                            placeholder={getLabel(2)}
                            value={password}
                            onChange={this.handelChange}
                        />
                    </div>
                </div>

                <div className="d-flex w-100 justify-content-between">
                    <div className="checkboxgroup">
                        <input id="remember" className="className" name="rememberMe" type="checkbox"
                            value={rememberMe} onChange={this.handelChange} />
                        <label htmlFor="remember">{getLabel(3)}</label>
                    </div>
                </div>

                <div className="clearfix" />
                <div className="actionbuttons">
                    <input className="btn btn-primary" onClick={this.submitForm} type="submit" value="Login" />
                    <span className="handwritten">{getLabel(233)}</span>
                    {/*<FacebookLogin*/}
                    {/*    appId="1575374426048627"*/}
                    {/*    autoLoad={false}*/}
                    {/*    fields="name, email"*/}
                    {/*    disableMobileRedirect={true}*/}
                    {/*    icon="fa-facebook"*/}
                    {/*    textButton={getLabel(229)}*/}
                    {/*    cssClass="btn btn-facebook btn-block"*/}
                    {/*    onClick={this.componentClicked}*/}
                    {/*    callback={this.responseFacebook} />*/}
                    <a onClick={this.loginWIthTwtter} className="btn btn-info">
                        <i className="fa fa-twitter" /> {getLabel(230)}
                    </a>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);
